import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PageModal from '../../common/PageModal'
import SimpleButton from '../../common/SimpleButton'
import TooltipedIcon from '../../common/TooltipedIcon'
import { no_image_200x200 } from '../../../images'
import { InformationIcon } from '../../../icons'
import '../uploads.scss'

const formatBytes = (bytes) => {
  const n = Number(bytes || 0)
  if (!n) return '-'
  const k = 1024
  const units = ['B', 'KB', 'MB', 'GB']
  const i = Math.min(Math.floor(Math.log(n) / Math.log(k)), units.length - 1)
  const v = n / Math.pow(k, i)
  return `${v >= 10 || i === 0 ? Math.round(v) : v.toFixed(1)} ${units[i]}`
}

const ViewModelImageModal = (props) => {
  const { t } = useTranslation()
  const { imageDetails, closeModal, onDownload } = props

  const meta = useMemo(() => {
    const imageTitle = imageDetails?.imageTitle || '-'
    const size = formatBytes(imageDetails?.fileSize)
    const dims = imageDetails?.width && imageDetails?.height ? `${imageDetails.width} x ${imageDetails.height}` : '-'
    return { imageTitle, size, dims }
  }, [imageDetails])

  return (
    <PageModal
      toggle
      onToggle={closeModal}
      className="uploads-modal model-image-view-modal"
      footerContent={
        <div className="footer-content">
          <div className="d-flex flex-align-center flex-justify-start">
            <div className="meta">
              <div className="name" title={meta.imageTitle}>
                {meta.imageTitle?.toUpperCase()}
              </div>
              <div className="sub">
                <span>{meta.size}</span>
                {meta.dims !== '-' && (
                  <>
                    <span className="dot">•</span>
                    <span>{meta.dims}</span>
                  </>
                )}
              </div>
            </div>
            <TooltipedIcon icon={<InformationIcon />} tooltipText={`${t('product_models_context.image_meta_info')}`} />
          </div>
          <SimpleButton className="submit-button" onClick={onDownload} disabled={!imageDetails?.filePath}>
            {t('download')}
          </SimpleButton>
        </div>
      }
    >
      <div className="uploads-modal-content content">
        <div className="canvas">
          <img className="img" src={imageDetails.url || no_image_200x200} alt={imageDetails?.fileName || 'image'} />
        </div>
      </div>
    </PageModal>
  )
}

export default ViewModelImageModal
